"use client";

export function ResetPage({ reset }: { reset: VoidFunction }) {
  return (
    <div>
      <h1>Something went wrong!</h1>
      <button onClick={reset}>Try again</button>
    </div>
  );
}
